export const THROTTLE_DELAY = 1000;

export const interactionEvents = [
  'mousemove',
  'keydown',
  'mousedown',
  'touchstart',
  'scroll',
];
